import React from 'react';
import { useNavigate } from 'react-router-dom';
import { requestLeave } from '../navGuard';

/**
 * An in-app link that behaves like a website link: a plain click navigates
 * inside the app (asking a page with unsaved work first, navGuard.ts);
 * Cmd/Ctrl-click, Shift-click, middle-click and "Open in new tab" open it in
 * another browser tab, leaving this page as it is.
 */
export const opensNewTab = (e: React.MouseEvent) => e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0;

const AppLink: React.FC<React.AnchorHTMLAttributes<HTMLAnchorElement> & { to: string }> = ({ to, onClick, children, ...rest }) => {
  const navigate = useNavigate();
  return (
    <a
      href={to}
      onClick={(e) => {
        onClick?.(e);
        if (e.defaultPrevented || opensNewTab(e)) return;
        e.preventDefault();
        requestLeave(() => navigate(to));
      }}
      {...rest}
    >
      {children}
    </a>
  );
};

export default AppLink;
